{
  "announcement": "Announcement",
  "schedule": "Schedule",
  "program": "Program",
  "urgent": "Urgent",
  "pinned": "Pinned",
  "cancelled": "Cancelled",
  "regOpen": "Registration open",
  "regOpenSeats": "Registration open · {count} slots left",
  "regOpenSeat": "Registration open · 1 slot left",
  "regWaitlist": "Full · join the waitlist",
  "regFull": "Full",
  "regClosed": "Registration closed",
  "regNotOpen": "Registration opens {date}",
  "regApproval": "Needs approval",
  "registered": "You're registered",
  "waitlisted": "You're on the waitlist",
  "pendingApproval": "Waiting for approval",
  "register": "Register",
  "joinWaitlist": "Join the waitlist",
  "viewTicket": "View my ticket",
  "addToCalendar": "Add to calendar",
  "getDirections": "Get directions",
  "share": "Share",
  "shareText": "From {office} on {app}",
  "eligibility": "Who can join",
  "venue": "Where",
  "when": "When",
  "sessions": "Schedules",
  "seatsLeft": "{count} slots left",
  "seatLeft": "1 slot left",
  "noLimit": "Open",
  "sessionFull": "Full",
  "attachments": "Attachments",
  "postedBy": "Posted by {office}",
  "lastEdited": "Last edited {date}",
  "forBarangays": "For residents of {list}",
  "cancelledBecause": "This event was cancelled: {reason}",
  "notFound": "This post isn't available. It may have ended or been archived.",
  "follow": "Follow",
  "following": "Following",
  "followOffice": "Follow {name}",
  "unfollowOffice": "Stop following {name}",
  "followHint": "Get notified when this office posts.",
  "signInToFollow": "Sign in to follow offices and get notified.",
  "pushPromptTitle": "Get notified?",
  "pushPromptBody": "Turn on notifications for new posts, registration updates and reminders.",
  "pushEnable": "Turn on notifications",
  "pushLater": "Not now",
  "pushOn": "Notifications are on.",
  "pushBlocked": "Notifications are blocked in your browser settings.",
  "pushUnsupported": "This browser can't receive notifications. On iPhone, add the app to your Home Screen first.",
  "tomorrow": "Tomorrow",
  "happeningNow": "Happening now",
  "ended": "Ended",
  "urgentNote": "Urgent notice from this office. Please read it now.",
  "cancelledNoReason": "This event was cancelled.",
  "forEveryone": "Everyone in {town}",
  "inBarangay": "Barangay {name}",
  "venueMapLabel": "Map showing {venue}",
  "attachment": "Attachment",
  "image": "Image",
  "followingOffice": "Following {name}",
  "registration": "Registration",
  "mineConfirmed": "Your slot is confirmed. Show your ticket's QR code at the venue.",
  "mineWaitlisted": "The event is full. We'll notify you right away if a slot opens.",
  "minePending": "The office is reviewing your registration. We'll let you know.",
  "waitlistExplain": "It's full right now. Join the waitlist and you'll get the next open slot automatically; we'll notify you.",
  "fullNoWaitlist": "This is full and has no waitlist.",
  "regClosedExplain": "Registration for this is closed.",
  "regCloses": "Registration closes {date}",
  "registerFor": "Register: {title}",
  "noRegistration": "This post doesn't take registrations.",
  "backToPost": "Back to the post",
  "alreadyRegistered": "You already registered for this. Your ticket shows your status.",
  "eligibilityNote": "Who can join: {text}",
  "chooseSession": "Choose a schedule",
  "sessionWaitlist": "Full · waitlist",
  "prefilledNote": "We filled in some details from your profile. Check them before you continue.",
  "companionsHint": "People coming with you. Each one takes a slot.",
  "chooseOption": "Choose…",
  "continueReview": "Review my registration",
  "fixErrors": "Please check the highlighted fields.",
  "errRequired": "This is required",
  "errTick": "Please tick this box",
  "errMobile": "Enter a mobile number like 0917 123 4567",
  "errEmail": "Enter a valid email",
  "errAge": "Enter an age from 0 to 130",
  "errConsent": "Please agree to the privacy notice to continue",
  "reviewTitle": "Check your details",
  "reviewLead": "Make sure everything is correct, then confirm.",
  "sessionLabel": "Schedule",
  "editAnswers": "Edit my answers",
  "approvalExplain": "The office reviews each registration. You'll be notified once it's approved.",
  "confirmRegister": "Confirm and register",
  "confirmWaitlist": "Confirm and join the waitlist",
  "sending": "Sending…",
  "doneConfirmed": "You're registered!",
  "doneConfirmedBody": "Your ticket is ready. Show its QR code at the venue.",
  "doneWaitlisted": "You're on the waitlist",
  "doneWaitlistedBody": "You're number {position} on the waitlist. If a slot opens, you'll get it automatically and we'll notify you.",
  "donePending": "Registration received",
  "donePendingBody": "The office will review it and let you know.",
  "seeMyRegistrations": "See all my registrations",
  "answerYes": "Yes",
  "answerNo": "No",
  "fileHint": "A photo or a PDF (up to 2 MB). Only the office can see it.",
  "fileChoose": "Choose a file",
  "fileUploading": "Uploading…",
  "fileUploaded": "File uploaded",
  "fileRemove": "Remove file",
  "field_name": "Full name",
  "field_mobile": "Mobile number",
  "field_email": "Email",
  "field_barangay": "Barangay",
  "field_address": "Address",
  "field_birthdate": "Birthdate",
  "field_age": "Age",
  "field_sex": "Sex",
  "field_rsbsa": "RSBSA number",
  "field_senior_pwd_id": "Senior citizen / PWD ID number",
  "field_school": "School",
  "field_companions": "Number of companions",
  "sex_female": "Female",
  "sex_male": "Male",
  "sex_prefer_not_to_say": "Prefer not to say",
  "ticketTitle": "My ticket",
  "ticketNotFound": "We couldn't find this ticket.",
  "ticketCode": "Ticket code",
  "ticketShowQr": "Show this QR code at the venue. You can also give the ticket code.",
  "ticketWaitlistBody": "If a slot opens, you move up automatically and we'll notify you.",
  "ticketPendingBody": "The office is reviewing your registration. Your QR code appears once it's approved.",
  "qrAlt": "QR code for ticket {code}",
  "checkedIn": "Checked in {time}",
  "waitlistPosition": "You're number {position} on the waitlist",
  "declined": "Not approved",
  "declinedBody": "The office could not approve this registration.",
  "officeNote": "Note from the office: {note}",
  "registrationCancelled": "Cancelled",
  "cancelledOn": "Cancelled {date}",
  "groupSize": "Group",
  "youPlusCompanion": "You + 1 companion",
  "youPlusCompanions": "You + {count} companions",
  "registeredOn": "Registered",
  "viewEvent": "View the event",
  "yourAnswers": "Your answers",
  "cancelRegistration": "Cancel my registration",
  "cancelUntil": "You can cancel until {date}.",
  "cancelClosed": "The cancellation deadline has passed. Contact the office if you can't come.",
  "cancelConfirmTitle": "Cancel your registration?",
  "cancelConfirmBody": "Your slot will go to the next person on the waitlist. You may not get it back.",
  "cancelConfirmWaitlist": "You will leave the waitlist.",
  "cancelYes": "Yes, cancel",
  "cancelKeep": "Keep it",
  "cancelDone": "Your registration was cancelled."
}
